// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"787":"e99029906d98dc33","835":"bb493506f68cd393"}[chunkId] + ".css";
};